import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeModalAction } from '../../../actions/modal';
import { releaseVendor, siteCompleteTicketMilestone } from '../../../actions/service_request';
import ButtonScogoClosedOutlined from '../../../common/Buttons/ButtonScogoClosedOutlined';
import ButtonScogoPrimary from '../../../common/Buttons/ButtonScogoPrimary';
import RenderMilestones from '../components/RenderMileStones';

export const formName = 'release_ticket';

const ReleaseTicket = ({ ticketId, milestones, agents }) => {
    const dispatch = useDispatch();
    const [selectedMilestones, setSelectedMilestones] = useState();
    const formButtonLoading = useSelector(state => state.loading.formButtonLoading);

    const handleSubmit = () => {
        dispatch(releaseVendor({ ticketId, milestoneId: selectedMilestones, formName, closeModal: true }));
    };

    const handleCancel = () => {
        dispatch(closeModalAction());
    };

    return (
        <div className='px-6 py-4'>
            <RenderMilestones milestones={milestones} selectedMilestones={selectedMilestones} setSelectedMilestones={setSelectedMilestones} agents={agents} />
            <div className="flex flex-col gap-6 pt-2">
                <div className="flex flex-col gap-3">
                    <h3 className="text-xl font-semibold text-gray-900">Release Ticket</h3>
                    <p className="text-base text-gray-600">Are you sure you want to release the ticket?</p>
                </div>

                <div className="flex justify-end gap-4 mt-4">
                    <ButtonScogoPrimary onClick={handleSubmit} textOrComponent='Confirm' loading={formButtonLoading[formName]} />
                    <ButtonScogoClosedOutlined onClick={handleCancel} textOrComponent='Cancel' />
                </div>
            </div>
        </div>
    );
};

export default ReleaseTicket;
